import { initEEBlobShow } from 'ee/blob/show/blob_show_bundle';

initEEBlobShow();
